// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiastes",
  bookSlug: "ecclesiastes",
  chapter: 6,
  argument: "The misery of the covetous man.",
  verses: [
    { n: 1, text: "There is also another evil, which I have seen under the sun, and that frequent among men:" },
    { n: 2, text: "A man to whom God hath given riches, and substance, and honour, and his soul wanteth nothing of all that he desireth: yet God doth not give him power to eat thereof, but a stranger shall eat it up. This is vanity and a great misery." },
    { n: 3, text: "If a man beget a hundred children, and live many years, and attain to a great age, and his soul make no use of the goods of his substance, and he be without burial: of this man I pronounce, that the untimely born is better than he." },
    { n: 4, text: "For he came in vain, and goeth to darkness, and his name shall be wholly forgotten." },
    { n: 5, text: "He hath not seen the sun, nor known the distance of good and evil:" },
    { n: 6, text: "Although he lived two thousand years, and hath not enjoyed good things: do not all make haste to one place?" },
    { n: 7, text: "All the labour of man is for his mouth, but his soul shall not be filled." },
    { n: 8, text: "What hath the wise man more than the fool? and what the poor man, but to go thither, where there is life?" },
    { n: 9, text: "Better it is to see what thou mayst desire, than to desire that which thou canst not know. But this also is vanity, and presumption of spirit." },
    { n: 10, text: "He that shall be, his name is already called: and it is known that he is man, and cannot contend in judgment with him that is stronger than himself." },
    { n: 11, text: "There are many words that have much vanity in disputing." },
  ],
  commentary: [
    { verse: 2, notes: [
      { text: "Thereof. \"Di tibi divitias dederunt artemque fruendi.\" (Horace, i. Ep. 4.) — The proper use of riches is rare. (Calmet) — Misery. Riches do not make people happy.", attribution: "Worthington" }
    ] },
    { verse: 3, notes: [
      { text: "Than he, since the latter has injured no one, nor experienced any evil in the world, (Calmet) by his own fault; (Menochius) whereas the miser has both hurt himself and others, and has neglected to make himself friends of the mammon of iniquity.", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "He. The infant, though some explain it of the miser.", attribution: "Calmet" }
    ] },
    { verse: 7, notes: [
      { text: "Mouth. We are always providing food. (St. Jerome) — The rich are wholly bent on pleasure; or the poor cannot get a sufficiency.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Life. The wise poor shall be blessed. Hebrew, \"the poor knowing how to walk before the living,\" (Haydock) in society (Calmet) among the saints.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Know. Enjoyment has the advantage over hope. Hebrew, \"better is the sight of the eyes than the going of the soul,\" which denotes her desires. (Calmet) — Presumption. Hebrew, \"vexation.\"", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: "He, &c. This is plainly spoken of Christ, whose name was given before he was born; (St. Jerome; Worthington) or men resemble each other in all ages, (chap. i. 9.; Calmet) being proud, fragile, &c.", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Disputing. Are we better acquainted with nature than former ages? This is another subject of confusion.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
